import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import DetailToolBar from '../fw/DetailToolBar.react.js';
import DetailBox from '../fw/DetailBox.react.js';
import TableDetail from '../fw/TableDetail.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import SafeHTML from '../fw/SafeHTML.react';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'eventView.title', 'defaultMessage': 'Event'}
});

interface EventViewProps {
    intl: IntlShape;
    user: User;
}

class EventView extends React.Component<EventViewProps> {

    typeName = 'events';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    render() {
        let { user } = this.props;
        let { event } = user.organisation.channel;

        let type = types[this.typeName];

        let content = event.row;
        try {
            content = JSON.parse(content);
        } catch (e) {
            /* ignore error */
        }

        if (typeof content !== "string") {
            content = JSON.stringify(content, null, 4);
            const maxLength = 100000;
            if (content.length > maxLength) {
                content = content.substring(0, maxLength) + "...";
            }
        }

        return (
            <AppPanel breadcrumbParams={[
                {type, data: event},
                {type: types['channels'], data: this.props.user.organisation.channel},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <div className="event-page">

                    <DetailBox data={event} metadata={type} urlMapping={urlMapping}>
                        <DetailToolBar data={event} metadata={type} organisationId={this.props.user.organisation.realId} urlMapping={urlMapping} />

                        <h2>Change event {event.eventType} {event.key}</h2>

                        <TableDetail columns={['eventType', 'createdAt', 'sourceDef.name', 'key']} data={event} metadata={type} />

                        <pre><SafeHTML value={'<small>' + content.replace(/[\u00A0-\u9999<>\&]/gim, (i) => '&#' + i.charCodeAt(0) + ';').replace(new RegExp(/\\n/, 'g'), '<br/>') + '</small>'} /></pre>
                    </DetailBox>
                </div>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(EventView), (props) => {
    return props.user.organisation && props.user.organisation.channel && props.user.organisation.channel.event;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        eventId: ''
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        name,
                        channelDef {
                            id,
                            name
                        },
                        event(id: $eventId) {
                            id,
                            organisation_id,
                            channel_id,
                            channelDef {
                                id,
                                name,
                            },
                            sourceDef {
                                id,
                                name,
                            },
                            key,
                            row,
                            eventType,
                            createdAt,
                        }
                    }
                }
            }
        `,
    },
});
